import script from "./PayDepositModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayDepositModal.vue?vue&type=script&setup=true&lang=ts"

import "./PayDepositModal.vue?vue&type=style&index=0&id=7d3c24aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d3c24aa"]])

export default __exports__